import Vue from "vue";
import VueRouter from "vue-router";
import firebase from "firebase/app";
import "firebase/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/ping",
    name: "Ping",
    component: () => import(/* webpackChunkName: "ping" */ "../views/Ping.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/user-profile",
    name: "UserProfile",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "user-profile" */ "../views/UserProfile.vue"),
  },
  {
    path: "/register",
    name: "Register",
    meta: {
      requiresAuth: false,
    },
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/Register.vue"),
  },
  {
    path: "/terms-of-use",
    name: "TermsOfUseView",
    meta: {
      requiresAuth: false,
    },
    component: () =>
      import(/* webpackChunkName: "terms-of-use" */ "../views/TermsOfUse.vue"),
  },
  {
    path: "/privacy-disclosures",
    name: "PrivacyDisclosuresView",
    meta: {
      requiresAuth: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "privacy-disclosures" */ "../views/PrivacyDisclosures.vue"
      ),
  },
  {
    path: "/admin/users",
    name: "Users",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "admin-users" */ "../views/admin/Users.vue"),
  },
  {
    path: "/admin/reviews",
    name: "ReviewsAdmin",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-reviews" */ "../views/admin/Reviews.vue"
      ),
  },
  {
    path: "/course/:courseId",
    name: "CourseProfile",
    meta: {
      requiresAuth: false,
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "course-profile" */ "../views/CourseProfile.vue"
      ),
  },
  {
    path: "/course-rating/:courseId",
    name: "UserCourseRating",
    meta: {
      requiresAuth: true,
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "course-rating" */ "../components/UserCourseRating.vue"
      ),
  },
  {
    path: "/register-success",
    name: "RegisterSuccess",
    meta: {
      requiresAuth: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "register-success" */ "../views/RegisterSuccess.vue"
      ),
  },
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const currentUser = firebase.auth().currentUser;

  if (requiresAuth && !currentUser) {
    next({
      name: "Login",
      params: {
        nextUrl: to.fullPath,
      },
    });
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

export default router;
